<template>
  <!-- 中奖记录 -->
  <div class="recorded">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['抽奖管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">类型：</label>
        <el-select
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部" value="All"></el-option>
          <el-option label="中奖记录" value="False"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.start"
          style="margin-right: 5px"
          type="date"
          clearable
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.end"
          style="margin-right: 5px"
          type="date"
          clearable
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择截至日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="clientNum"
        show-overflow-tooltip
        label="中奖客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="clientName"
        align="center"
        show-overflow-tooltip
        label="中奖客户名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="prizeImg"
        show-overflow-tooltip
        label="奖品图片"
      >
        <template slot-scope="scope">
          <img-view :imgList="[{ url: scope.row.prizeImg, id: 0 }]"></img-view>
        </template>
      </el-table-column>
      <el-table-column
        prop="prizeNum"
        label="奖品编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="prizeName"
        label="奖品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="prizeType"
        label="奖品类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="prizeVal"
        label="奖品价值/优惠券编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="winTime"
        label="中奖时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "recorded",
  data() {
    return {
      /**表格数据 */
      // {
      //   clientNum:"中奖客户编号",
      //   clientName:"中奖客户名称",
      //   prizeImg:"奖品图片",
      //   prizeNum:"奖品编号",
      //   prizeName:"奖品名称",
      //   prizeType:"奖品类型",
      //   prizeVal:"奖品价值",
      //   winTime:"中奖时间"
      // }
      tableData: [],
      searchForm: {
        type: "All",
        name: "",
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取管理员数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (!this.searchForm.start) {
        this.$message({
          message: "请输入开始时间",
          type: "warning",
        });
        return;
      }
      if (!this.searchForm.end) {
        this.$message({
          message: "请输入结束时间",
          type: "warning",
        });
        return;
      }
      this.$request({
        url:
          "Lottery/LotteryHis?keyword=" +
          this.searchForm.name +
          "&selectType=" +
          this.searchForm.type +
          "&pageSize=" +
          this.pageSize +
          "&pageIndex=" +
          this.currPage +
          "&start=" +
          this.searchForm.start +
          "&end=" +
          this.searchForm.end +
          "&entId=" +
          window.localStorage.getItem("entId"),
        method: "get",
      })
        .then((res) => {
          this.tableData = [];
          if (res.Code == 0) {
            this.allPage = res.TotalCount;
            for (let i = 0; i < res.Source.length; i++) {
              this.tableData.push({
                clientNum: res.Source[i].UserID,
                clientName: res.Source[i].UserName,
                prizeImg: res.Source[i].ImgUrl,
                prizeNum: res.Source[i].PrizeBH,
                prizeName: res.Source[i].PrizeName,
                prizeType: res.Source[i].PrizeType,
                prizeVal: res.Source[i].PrizeCount,
                winTime: res.Source[i].LuckyTime,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.recorded {
  width: 100%;
  height: 100%;
}
</style>
